/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ccsl_Export_Template_LabelInputs */

const en_ccsl_export_template_label = /** @type {(inputs: Ccsl_Export_Template_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CCSL Template`)
};

const fr_ccsl_export_template_label = /** @type {(inputs: Ccsl_Export_Template_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modele CCSL`)
};

const de_ccsl_export_template_label = /** @type {(inputs: Ccsl_Export_Template_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CCSL-Vorlage`)
};

const it_ccsl_export_template_label = /** @type {(inputs: Ccsl_Export_Template_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modello CCSL`)
};

const ru_ccsl_export_template_label = /** @type {(inputs: Ccsl_Export_Template_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Шаблон CCSL`)
};

const es_ccsl_export_template_label = /** @type {(inputs: Ccsl_Export_Template_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plantilla CCSL`)
};

const zh_cn2_ccsl_export_template_label = /** @type {(inputs: Ccsl_Export_Template_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CCSL模板`)
};

const ja_ccsl_export_template_label = /** @type {(inputs: Ccsl_Export_Template_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CCSL テンプレート`)
};

const hi_ccsl_export_template_label = /** @type {(inputs: Ccsl_Export_Template_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`सीसीएसएल टेम्पलेट`)
};

const pt_pt2_ccsl_export_template_label = /** @type {(inputs: Ccsl_Export_Template_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modelo CCSL`)
};

/**
* | output |
* | --- |
* | "CCSL Template" |
*
* @param {Ccsl_Export_Template_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ccsl_export_template_label = /** @type {((inputs?: Ccsl_Export_Template_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ccsl_Export_Template_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_ccsl_export_template_label(inputs)
	if (locale === "de") return de_ccsl_export_template_label(inputs)
	if (locale === "it") return it_ccsl_export_template_label(inputs)
	if (locale === "ru") return ru_ccsl_export_template_label(inputs)
	if (locale === "es") return es_ccsl_export_template_label(inputs)
	if (locale === "zh-CN") return zh_cn2_ccsl_export_template_label(inputs)
	if (locale === "ja") return ja_ccsl_export_template_label(inputs)
	if (locale === "hi") return hi_ccsl_export_template_label(inputs)
	if (locale === "pt-PT") return pt_pt2_ccsl_export_template_label(inputs)
	return en_ccsl_export_template_label(inputs)
});